import React, { useEffect } from "react";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Container, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));
const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const Faq = () => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const [expanded, setExpanded] = React.useState("panel1");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <div>
      <Container>
        <Box className={classes.product__inner}>
          <Typography
            className="title"
            sx={{
              textAlign: "center",
              pb: 1,
              pt: 2,
              fontSize: "17px",
              fontWeight: 600,
            }}
          >
            {t("Heslet's Return Policy")}
          </Typography>
          <Box sx={{ textAlign: "center", pb: 2, fontSize: "16px" }}>
            {t("These are the list of frequently asked questions.")}
          </Box>

          <Grid container sx={{ width: 1, paddingTop: "20px" }}>
            <Accordion
              expanded={expanded === "panel1"}
              onChange={handleChange("panel1")}
            >
              <AccordionSummary
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <Typography>상품결제정보</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  고액결제의 경우 안전을 위해 카드사에서 확인전화를 드릴 수도
                  있습니다. <br />
                  <br />
                  확인과정에서 도난 카드의 사용이나 타인 명의의 주문등 정상적인
                  주문이 아니라고 판단될 경우 임의로 주문을 보류 또는 취소할 수
                  있습니다. <br />
                  <br />
                  무통장 입금은 상품 구매 대금은 PC뱅킹, 인터넷뱅킹, 텔레뱅킹
                  혹은 가까운 은행에서 직접 입금하시면 됩니다. 주문시 입력한
                  입금자명과 실제입금자의 성명이 반드시 일치하여야 하며, 7일
                  이내로 입금을 하셔야 하며 입금되지 않은 주문은 자동취소
                  됩니다.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expanded === "panel2"}
              onChange={handleChange("panel2")}
            >
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography>배송정보</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                  eget. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                  eget.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expanded === "panel3"}
              onChange={handleChange("panel3")}
            >
              <AccordionSummary
                aria-controls="panel3d-content"
                id="panel3d-header"
              >
                <Typography>교환 및 반품정보</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                  eget. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                  eget.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Grid>
        </Box>
      </Container>
    </div>
  );
};

export default Faq;
const useStyles = makeStyles({
  product__inner: {
    paddingBottom: "100px",
    minHeight: "60vh",
    paddingTop: "40px",
  },

  product__content: {
    display: "flex",
    alignItems: "center",
  },
  product__img: { maxWidth: "500px", minWidth: "200px", borderRadius: "2%" },
});
